export var AgentOperationLogsCategoryType;
(function (AgentOperationLogsCategoryType) {
    AgentOperationLogsCategoryType["SETTING"] = "agent_setting";
    AgentOperationLogsCategoryType["LAYER"] = "agent_layer";
    AgentOperationLogsCategoryType["WALLET"] = "agent_wallet";
    AgentOperationLogsCategoryType["PLAYER_ACCOUNT"] = "agent_member";
    AgentOperationLogsCategoryType["ASSISTANT"] = "agent_assistant_account";
    AgentOperationLogsCategoryType["ANNOUNCEMENT"] = "agent_announcement";
    AgentOperationLogsCategoryType["MEMO"] = "memo";
})(AgentOperationLogsCategoryType || (AgentOperationLogsCategoryType = {}));
export var AgentOperationLogsSettingMethod;
(function (AgentOperationLogsSettingMethod) {
    AgentOperationLogsSettingMethod["LOGIN_PASSWORD"] = "\u767B\u5F55\u5BC6\u7801";
    AgentOperationLogsSettingMethod["SECURITY_PASSWORD"] = "\u5B89\u5168\u5BC6\u7801";
})(AgentOperationLogsSettingMethod || (AgentOperationLogsSettingMethod = {}));
export var AgentOperationLogsLayerMethod;
(function (AgentOperationLogsLayerMethod) {
    AgentOperationLogsLayerMethod["NEW_LAYER"] = "\u65B0\u589E\u5C42\u7EA7";
    AgentOperationLogsLayerMethod["ALLOW_LOGIN"] = "\u5141\u8A31\u767B\u5165";
    AgentOperationLogsLayerMethod["NICK_NAME"] = "\u6635\u79F0";
    AgentOperationLogsLayerMethod["LOGIN_PASSWORD"] = "\u767B\u5F55\u5BC6\u7801";
    AgentOperationLogsLayerMethod["PERCENTAGE"] = "\u62C6\u5E10\u6BD4";
})(AgentOperationLogsLayerMethod || (AgentOperationLogsLayerMethod = {}));
export var AgentOperationLogsWalletMethod;
(function (AgentOperationLogsWalletMethod) {
    AgentOperationLogsWalletMethod["DEPOSIT"] = "\u5145\u503C";
    AgentOperationLogsWalletMethod["TRANSFER"] = "\u8F6C\u5E10";
    AgentOperationLogsWalletMethod["AGENT_DEPOSIT"] = "\u7ECF\u9500\u4EE3\u5B58";
})(AgentOperationLogsWalletMethod || (AgentOperationLogsWalletMethod = {}));
export var AgentOperationLogsPlayerAccountMethod;
(function (AgentOperationLogsPlayerAccountMethod) {
    AgentOperationLogsPlayerAccountMethod["BUBBLE_ID"] = "\u6CE1\u6CE1 ID";
})(AgentOperationLogsPlayerAccountMethod || (AgentOperationLogsPlayerAccountMethod = {}));
export var AgentOperationLogsAssistantMethod;
(function (AgentOperationLogsAssistantMethod) {
    AgentOperationLogsAssistantMethod["NEW_ASSISTANT"] = "\u65B0\u589E\u5E10\u53F7";
    AgentOperationLogsAssistantMethod["NICK_NAME"] = "\u6635\u79F0";
    AgentOperationLogsAssistantMethod["TYPE"] = "\u8EAB\u4EFD";
    AgentOperationLogsAssistantMethod["ALLOW_LOGIN"] = "\u5141\u8A31\u767B\u5165";
    AgentOperationLogsAssistantMethod["LOGIN_PASSWORD"] = "\u767B\u5F55\u5BC6\u7801";
    AgentOperationLogsAssistantMethod["CUSTOM_PERMISSION"] = "\u81EA\u8BA2\u6743\u9650";
})(AgentOperationLogsAssistantMethod || (AgentOperationLogsAssistantMethod = {}));
export var AgentOperationLogsAnnouncementMethod;
(function (AgentOperationLogsAnnouncementMethod) {
    AgentOperationLogsAnnouncementMethod["STAFF_ANNOUNCEMENT"] = "\u7ECF\u9500\u516C\u544A";
})(AgentOperationLogsAnnouncementMethod || (AgentOperationLogsAnnouncementMethod = {}));
export var AgentOperationLogsMemoMethod;
(function (AgentOperationLogsMemoMethod) {
    AgentOperationLogsMemoMethod["MEMO"] = "\u5907\u6CE8";
})(AgentOperationLogsMemoMethod || (AgentOperationLogsMemoMethod = {}));
//# sourceMappingURL=AgentOperationLogsCategoryType.js.map